import { HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AgenciasService } from 'src/app/_services/agencias.service';
import { ToursService } from 'src/app/_services/tours.service';
import { ModalAsientosComponent } from '../modal-asientos/modal-asientos.component';

@Component({
  selector: 'app-tours-confirmados',
  templateUrl: './tours-confirmados.component.html',
  styleUrls: ['./tours-confirmados.component.css']
})
export class ToursConfirmadosComponent implements OnInit, OnDestroy {

  subscription: Subscription;
  form: FormGroup;
  listPacks = [];
  listToursCnf = [];
  listaReservaciones = [];
  cantidadToursCnf: number;
  imagenTour: string;
  imagenDefault = '../assets/images/body/tours/01.jpg';
  idPaquete: Number;

  constructor(
    private modalService: NgbModal,
    private agenciasService:AgenciasService,
    private formBuilder: FormBuilder,
    private tourservice: ToursService,
    private router: Router,
  ) { }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      search: [''],     
    });
    //*** cargar listado de tours confirmados
    //this.reservacionesConfirmadas();
    this.paquetesConReservacion();

    this.subscription = this.tourservice.paqueteConfirmado.subscribe(result => {
      this.idPaquete = result;
    });
  }

  verAsientos(item:any){
    const modalRef = this.modalService.open(ModalAsientosComponent, { 
      centered: true,  
      backdrop:'static',      
      size:'lg'
    });

    modalRef.componentInstance.tipoTransporte = item.paquete.id_tipoBus;
    modalRef.componentInstance.passAsientos = item.paquete.asientos;
    modalRef.componentInstance.id = item.paquete.id;

    
  }

  toursConfirmados(){  
    this.listToursCnf = [];
    this.agenciasService.toursConfirmados().subscribe(data => {  
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          //console.log(data.body[1]);
          this.cantidadToursCnf = data.body.length;
          this.listToursCnf = data.body; 
          console.log('Tour confirmados:'+ JSON.stringify( this.listToursCnf));
        }
        //console.log("cantidad de tours confirmados:  " + this.cantidadToursCnf);  
        //console.log(this.listToursCnf);   
      }    
    });    
  }

  reservacionesConfirmadas(){  
    this.listaReservaciones = [];
    this.agenciasService.reservacionesConfirmadas().subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          this.listaReservaciones = data.body;

          this.listaReservaciones.forEach(element => {
            var pack = element.id_paquete.id;

            this.agenciasService.UntourReservado(pack).subscribe(data => {
              if(data instanceof HttpResponse){
                if(data.body !== null && data.body !== undefined && data.body !== ''){
                  var packrecibido = data.body[0];
                  var imgrecibida = packrecibido.imagen; 
                  element.imagen = imgrecibida; 
                }
              }
            });
          });
        }//console.log(this.listaReservaciones);
      }    
    });    
  }

  verAgenciasConfirmadas(id) {    
    this.idPaquete = id;
    this.tourservice.changePaqueteCnfId(this.idPaquete);
    //console.log("el paquete que se toco es:  "+id);
    this.router.navigate(['/admin/tours-agencias-confirmadas']);
  }

  paquetesConReservacion(){
    this.listPacks = [];
    this.agenciasService.viajesReservados('2').subscribe(data => {
      if(data instanceof HttpResponse){
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          this.listPacks = data.body.list; console.log(this.listPacks);
        }
      }
    });
  }

}
